<script lang="ts">
    import type {User} from 'src/typings';
    import {Kind} from 'shared/constants';
    import {getInjector, getLocalization} from 'src/core';
    import type {SearchManager} from '../../search-manager/search-manager';
    import {KpSearchItemUserPresenter} from './kp-search-item-user.presenter';
    import KpCollapsibleMenuWrapper from 'shared/ui-widgets/menu-wrapper/KpCollapsibleMenuWrapper.svelte';
    import KpUserInfoCard from '../../../user/KpUserInfoCard.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import KpUsernameLabel from '../../../user/KpUsernameLabel.svelte';
    import Label from 'shared/components/kp-label/Label.svelte';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';

    export let user: User;
    export let refreshSearchManager: SearchManager<User>;

    const localize = getLocalization();
    const presenter = getInjector().getByClass(KpSearchItemUserPresenter);

    async function editUser() {
        user = await presenter.editUser(user);
    }

    async function deleteUser() {
        await presenter.deleteUser(user);
        return refreshSearchManager.refreshSearch();
    }
</script>

<KpCollapsibleMenuWrapper>
    <div slot="main" class="list-item-user">
        <KpUserInfoCard {user} let:userData>
            <h2 class="unset-style nazevZaznamu">
                <Label labeled={userData} explicitKind={Kind.KIND_USER} additionalClasses="user-printable-name"/>
                {#if userData.username}
                    <KpUsernameLabel user={userData}/>
                {/if}
            </h2>
        </KpUserInfoCard>
    </div>

    <div slot="menu" let:collapsed>
        <li class="collapsible-menu-item">
            <KpButton noWrap isBlock={true} buttonSize="xs" on:click={editUser}>
                <UIcon icon="edit"/>
                <span class:sr-only={collapsed}>{localize(/* @kp-localization commons.editovat */ 'commons.editovat')}</span>
            </KpButton>
        </li>

        <li class="collapsible-menu-item">
            <KpButton noWrap isBlock={true} buttonSize="xs" on:click={deleteUser}>
                <UIcon icon="trash"/>
                <span class:sr-only={collapsed}>{localize(/* @kp-localization commons.Smazat */ 'commons.Smazat')}</span>
            </KpButton>
        </li>
    </div>
</KpCollapsibleMenuWrapper>